import './GalleryWixStyles.scss';
import './WixStyles.scss';
import './GalleryWrapper.scss';
